import type { Contract } from "@features/contracts/api";
import type { FormInstance } from "antd";
import { DatePicker, Form, Input, Space, Switch } from "antd";
import dayjs from "dayjs";
import { memo, useEffect } from "react";

interface ContractFormProps {
  form: FormInstance;
  initialData: Contract | null;
  disabled?: boolean;
  onValuesChange?: () => void;
}

const ContractForm = memo(function ContractForm({
  form,
  initialData,
  disabled = false,
  onValuesChange,
}: ContractFormProps) {
  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        inn: initialData.inn,
        contract_number: initialData.contract_number,
        company_name: initialData.company_name,
        start_date: initialData.start_date ? dayjs(initialData.start_date) : undefined,
        end_date: initialData.end_date ? dayjs(initialData.end_date) : undefined,
        comment: initialData.comment,
        auto_generate_80020: initialData.auto_generate_80020 ?? false,
      });
    } else {
      form.resetFields();
    }
  }, [form, initialData]);

  return (
    <Form form={form} layout="vertical" onValuesChange={onValuesChange} disabled={disabled}>
      <Form.Item name="inn" label="ИНН" rules={[{ required: true, message: "Укажите ИНН" }]}>
        <Input placeholder="ИНН организации" />
      </Form.Item>
      <Form.Item
        name="contract_number"
        label="Номер договора"
        rules={[{ required: true, message: "Укажите номер" }]}
      >
        <Input placeholder="Номер договора" />
      </Form.Item>
      <Form.Item
        name="company_name"
        label="Компания"
        rules={[{ required: true, message: "Укажите компанию" }]}
      >
        <Input placeholder="Название компании" />
      </Form.Item>
      <Space size="middle" style={{ width: "100%" }} wrap>
        <Form.Item name="start_date" label="Дата начала" style={{ minWidth: 200 }}>
          <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item name="end_date" label="Дата окончания" style={{ minWidth: 200 }}>
          <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
        </Form.Item>
      </Space>
      <Form.Item name="comment" label="Комментарий">
        <Input.TextArea rows={3} placeholder="Комментарий" />
      </Form.Item>
      <Form.Item
        name="auto_generate_80020"
        label="Автоформирование 80020"
        valuePropName="checked"
        extra="Ежемесячная генерация 1-го числа за предыдущий период"
      >
        <Switch />
      </Form.Item>
    </Form>
  );
});

export default ContractForm;
